.chartWrapper {
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;

  span {
    padding: 1rem;
    line-height: 0;
  }
}
